(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beam-collection-grid-navee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.__beamCollectionFacetsBound) {
      window.__beamCollectionFacetsBound = true;
      document.documentElement.classList.add('beam-js-facets');
      document.addEventListener('change', function (e) {
        var el = e.target;
        if (!el || !el.matches || !el.matches('[data-auto-submit]')) return;
        var form = el.closest('[data-facets-form], [data-sort-form]');
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    if (window.__beamNaveeCollectionGridBound) return;
    window.__beamNaveeCollectionGridBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-navee-filters-toggle]');
      if (!btn) return;
      var root = btn.closest('.beam-collection-grid-navee');
      if (!root) return;
      var open = root.getAttribute('data-filters-open') !== 'false';
      var next = !open;
      root.setAttribute('data-filters-open', next ? 'true' : 'false');
      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      var collapse = btn.querySelector('[data-navee-filters-label-collapse]');
      var expand = btn.querySelector('[data-navee-filters-label-expand]');
      if (collapse) collapse.hidden = !next;
      if (expand) expand.hidden = next;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__beamCollectionGridBound) return;
    window.__beamCollectionGridBound = true;

    /* Flag that JS is available so redundant apply/clear buttons can hide. */
    document.documentElement.classList.add('beam-js-facets');

    /* Progressive enhancement: submit filter / sort forms on change. */
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || !el.closest || !el.matches) return;
      if (!el.matches('[data-auto-submit]')) return;
      var form = el.closest('[data-facets-form], [data-sort-form]');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var headers = document.querySelectorAll('[data-beam-header]');
    headers.forEach(function (header) {
      // Fixed mega menus use viewport coordinates. Track the header's bottom
      // edge so they sit below the announcement bar, and follow it as that
      // bar scrolls away or changes height.
      var setHeaderOffset = function () {
        header.style.setProperty('--beam-header-h', header.getBoundingClientRect().bottom + 'px');
      };
      var onScroll = function () {
        if (header.classList.contains('beam-header--sticky')) {
          header.classList.toggle('is-scrolled', window.scrollY > 12);
        }
        setHeaderOffset();
      };
      setHeaderOffset();
      window.addEventListener('resize', setHeaderOffset, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('load', setHeaderOffset);
      if (window.ResizeObserver) {
        var offsetObserver = new ResizeObserver(setHeaderOffset);
        offsetObserver.observe(header);
        var announcement = document.querySelector('.beam-announcement-section');
        if (announcement) offsetObserver.observe(announcement);
      }

      // Desktop disclosure toggles (aria-expanded) + keyboard support
      var toggles = header.querySelectorAll('[data-nav-toggle]');
      var closeAll = function (except) {
        toggles.forEach(function (t) {
          if (t !== except) t.setAttribute('aria-expanded', 'false');
        });
      };
      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          closeAll(toggle);
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });

      // Showcase mega menu: category rail switches the product-card pane
      header.querySelectorAll('.beam-mega--showcase').forEach(function (mega) {
        var tabs = mega.querySelectorAll('[data-mega-tab]');
        var panes = mega.querySelectorAll('[data-mega-pane]');
        var activate = function (i) {
          tabs.forEach(function (t) {
            var on = t.getAttribute('data-mega-tab') === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-expanded', on ? 'true' : 'false');
          });
          panes.forEach(function (p) {
            var on = p.getAttribute('data-mega-pane') === i;
            p.classList.toggle('is-active', on);
            p.hidden = !on;
          });
        };
        tabs.forEach(function (t) {
          var i = t.getAttribute('data-mega-tab');
          t.addEventListener('mouseenter', function () { activate(i); });
          t.addEventListener('focus', function () { activate(i); });
        });
      });

      // Esc closes any open desktop panel and returns focus to its toggle
      header.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var item = e.target.closest('[data-nav-item]');
        if (!item) return;
        var toggle = item.querySelector('[data-nav-toggle]');
        if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
      });
    });

    // Click outside closes desktop panels
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-item]')) return;
      document.querySelectorAll('[data-nav-toggle][aria-expanded="true"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-lifestyle-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.beam-lifestyle-gallery').forEach(function (root) {
      var dialog = root.querySelector('[data-lightbox-dialog]');
      if (!dialog) return;
      var img = dialog.querySelector('[data-lightbox-img]');
      var lastFocus = null;

      function open(src, alt, trigger) {
        lastFocus = trigger || null;
        img.setAttribute('src', src);
        img.setAttribute('alt', alt || '');
        dialog.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var closeBtn = dialog.querySelector('[data-lightbox-close]');
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        dialog.hidden = true;
        img.setAttribute('src', '');
        document.documentElement.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }

      root.querySelectorAll('[data-lightbox-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          open(btn.getAttribute('data-lightbox-src'), btn.getAttribute('data-lightbox-alt'), btn);
        });
      });

      dialog.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !dialog.hidden) close();
      });
    });

    // Metaobject video items: poster + play button → inline muted loop.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.beam-lifestyle-gallery__play');
      if (!btn) return;
      var p = btn.closest('.beam-lifestyle-gallery__player');
      var v = p && p.querySelector('video');
      if (!v) return;
      p.classList.add('is-playing');
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-product-hero"] && !Shopify.designMode) return;
  try {
    
  class BeamBuybox extends HTMLElement {
    connectedCallback() {
      this.variantInput = this.querySelector('[data-variant-id]');
      this.quantityProxy = this.querySelector('[data-quantity-proxy]');
      this.priceTarget = this.querySelector('[data-buybox-price]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');
      this.addButtons = Array.from(this.querySelectorAll('[data-add-button], [data-sticky-add]'));
      this.checkoutButtons = Array.from(this.querySelectorAll('[data-checkout-now]'));
      this.labels = {
        add: this.dataset.labelAdd,
        soldout: this.dataset.labelSoldout,
        unavailable: this.dataset.labelUnavailable
      };
      const payload = this.querySelector('[data-buybox-variants]');
      try { this.variants = payload ? JSON.parse(payload.textContent) : []; }
      catch (e) { this.variants = []; }

      this.addEventListener('change', (e) => {
        if (e.target.closest('[data-option-group]')) this.onOptionChange();
        if (e.target.closest('[data-quantity-block]')) this.syncQuantity();
      });
      this.addEventListener('input', (e) => {
        if (e.target.closest('[data-quantity-block]')) this.syncQuantity();
      });
      this.addEventListener('click', (e) => {
        const share = e.target.closest('[data-share]');
        if (share) { e.preventDefault(); this.share(share); }
      });

      this.setupSticky();
      this.setupBundle();
      this.syncQuantity();
      this.onOptionChange();
    }

    /* ---------- Bundle mode (order summary + optional accessories) ---------- */
    setupBundle() {
      this.summary = this.querySelector('[data-order-summary]');
      if (!this.summary) return;
      this.accessoryToggles = Array.from(this.querySelectorAll('[data-accessory-toggle]'));
      this.summaryAccessories = this.summary.querySelector('[data-summary-accessories]');
      const mainPriceEl = this.summary.querySelector('[data-summary-main-price]');
      this.mainCents = mainPriceEl ? parseInt(mainPriceEl.dataset.priceCents, 10) || 0 : 0;

      this.accessoryToggles.forEach((box) => {
        box.addEventListener('change', () => this.renderBundle());
      });

      const form = this.querySelector('[data-bundle-form]');
      if (form) {
        form.addEventListener('submit', (e) => { e.preventDefault(); this.bundleAdd(form, false); });
        const buyNow = form.querySelector('[data-bundle-checkout]');
        if (buyNow) buyNow.addEventListener('click', () => this.bundleAdd(form, true));
      }
      this.renderBundle();
    }

    formatMoney(cents) {
      const fmt = this.dataset.moneyFormat || '{{ amount }}';
      const units = (cents / 100).toFixed(2);
      const [int, dec] = units.split('.');
      const intComma = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/, intComma + '.' + dec)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, intComma)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, int.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, int.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    }

    checkedAccessories() {
      return (this.accessoryToggles || []).filter((b) => b.checked && !b.disabled);
    }

    renderBundle() {
      if (!this.summary) return;
      const checked = this.checkedAccessories();
      if (this.summaryAccessories) {
        this.summaryAccessories.innerHTML = '';
        checked.forEach((box) => {
          const li = document.createElement('li');
          li.className = 'beam-product-hero__summary-line';
          const name = document.createElement('span');
          name.textContent = box.dataset.accessoryTitle;
          const price = document.createElement('span');
          price.textContent = this.formatMoney(parseInt(box.dataset.priceCents, 10) || 0);
          li.appendChild(name); li.appendChild(price);
          this.summaryAccessories.appendChild(li);
        });
        this.summaryAccessories.hidden = checked.length === 0;
      }
      const qtyInput = this.querySelector('[data-quantity-block] .beam-quantity__input');
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const total = this.mainCents * qty + checked.reduce((sum, b) => sum + (parseInt(b.dataset.priceCents, 10) || 0), 0);
      const totalText = this.formatMoney(total);
      const totalEl = this.summary.querySelector('[data-summary-total]');
      if (totalEl) totalEl.textContent = totalText;
      const inline = this.summary.querySelector('[data-summary-total-inline]');
      if (inline) inline.textContent = totalText;
      const mainEl = this.summary.querySelector('[data-summary-main-price]');
      if (mainEl) mainEl.textContent = this.formatMoney(this.mainCents * qty);
    }

    bundleItemsPayload(form) {
      const idInput = form.querySelector('[data-variant-id]');
      if (!idInput || !idInput.value) return null;
      const qtyProxy = form.querySelector('[data-quantity-proxy]');
      const items = [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyProxy && qtyProxy.value ? qtyProxy.value : '1', 10) || 1 }];
      this.checkedAccessories().forEach((box) => {
        items.push({ id: parseInt(box.dataset.accessoryId, 10), quantity: 1 });
      });
      return { items: items };
    }

    bundleAdd(form, checkout) {
      const payload = this.bundleItemsPayload(form);
      if (!payload) return;
      const button = checkout ? form.querySelector('[data-bundle-checkout]') : form.querySelector('[data-add-button]');
      if (button) { button.setAttribute('aria-disabled', 'true'); button.classList.add('is-loading'); }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then((r) => r.json().then((data) => {
          if (!r.ok || data.status) throw data;
          return data;
        }))
        .then(() => {
          if (checkout) { window.location.href = root + 'checkout'; return; }
          if (window.Beam && window.Beam.refreshDrawer) {
            window.Beam.refreshDrawer().then(() => {
              const drawer = document.getElementById('beam-cart-drawer-overlay');
              if (drawer && drawer.open) drawer.open(button);
            });
          }
        })
        .catch((err) => {
          const msg = form.querySelector('[data-form-error]');
          if (msg) msg.textContent = (err && (err.description || err.message)) || 'Could not add to cart.';
        })
        .finally(() => {
          if (button) { button.removeAttribute('aria-disabled'); button.classList.remove('is-loading'); }
        });
    }

    currentOptions() {
      return Array.from(this.querySelectorAll('[data-option-group]')).map((g) => {
        const checked = g.querySelector('input:checked');
        if (checked) return checked.value;
        const sel = g.querySelector('select');
        return sel ? sel.value : null;
      });
    }

    findVariant(opts) {
      return this.variants.find((v) =>
        v.options.length === opts.length && v.options.every((o, i) => o === opts[i])
      );
    }

    onOptionChange() {
      this.querySelectorAll('[data-option-group]').forEach((g) => {
        const out = g.querySelector('[data-selected-value]');
        if (!out) return;
        const checked = g.querySelector('input:checked');
        const sel = g.querySelector('select');
        out.textContent = checked ? checked.value : (sel ? sel.value : '');
      });

      const optionGroups = this.querySelectorAll('[data-option-group]');
      let variant = null;

      if (optionGroups.length > 0) {
        const opts = this.currentOptions();
        if (opts.indexOf(null) === -1) variant = this.findVariant(opts);
      } else {
        const id = this.variantInput ? parseInt(this.variantInput.value, 10) : NaN;
        variant = this.variants.find((v) => v.id === id) || this.variants[0] || null;
      }

      if (variant) {
        this.querySelectorAll('[data-variant-id]').forEach((inp) => { inp.value = variant.id; });
        this.updatePrice(variant);
        this.updateAvailability(variant.available ? 'add' : 'soldout', !variant.available);
        if (variant.media != null) {
          this.dispatchEvent(new CustomEvent('beam:variant-media', { bubbles: true, detail: { media: variant.media } }));
        }
      } else {
        this.updateAvailability('unavailable', true);
      }
    }

    updatePrice(variant) {
      if (this.summary && typeof variant.cents === 'number') {
        this.mainCents = variant.cents;
        const bundleMain = this.querySelector('[data-bundle-main-price]');
        if (bundleMain) bundleMain.textContent = variant.price;
        const bundleCompare = this.querySelector('[data-bundle-main-compare]');
        if (bundleCompare) { bundleCompare.textContent = variant.compare || ''; bundleCompare.hidden = !variant.compare; }
        this.renderBundle();
      }
      [this.priceTarget, this.stickyPrice].forEach((t) => {
        if (!t) return;
        const wrap = t.querySelector('.beam-price');
        const reg = t.querySelector('.beam-price__regular');
        let cmp = t.querySelector('.beam-price__compare');
        if (reg) reg.textContent = variant.price;
        if (variant.compare) {
          if (!cmp && wrap) { cmp = document.createElement('s'); cmp.className = 'beam-price__compare'; wrap.appendChild(cmp); }
          if (cmp) { cmp.textContent = variant.compare; cmp.hidden = false; }
          if (wrap) wrap.classList.add('beam-price--on-sale');
        } else {
          if (cmp) cmp.hidden = true;
          if (wrap) wrap.classList.remove('beam-price--on-sale');
        }
      });
    }

    updateAvailability(key, disabled) {
      const text = this.labels[key] || this.labels.add;
      this.addButtons.forEach((b) => {
        b.disabled = disabled;
        const l = b.querySelector('[data-add-label]');
        if (l) l.textContent = text;
      });
      (this.checkoutButtons || []).forEach((b) => { b.disabled = disabled; });
    }

    syncQuantity() {
      const input = this.querySelector('[data-quantity-block] .beam-quantity__input');
      if (input && this.quantityProxy) this.quantityProxy.value = input.value || 1;
      const bundleProxy = this.querySelector('[data-bundle-form] [data-quantity-proxy]');
      if (input && bundleProxy) bundleProxy.value = input.value || 1;
      if (this.summary) this.renderBundle();
    }

    setupSticky() {
      const bar = this.querySelector('[data-sticky-bar]');
      const sentinel = this.querySelector('[data-add-button]');
      if (!bar || !sentinel || !('IntersectionObserver' in window)) return;

      const mq = window.matchMedia('(max-width: 749px)');
      const header = document.querySelector('[data-beam-header]');
      const main = document.getElementById('MainContent');

      this._stickyEnsureSpacer = () => {
        if (!main) return null;
        if (!this._stickySpacer || !this._stickySpacer.isConnected) {
          this._stickySpacer = main.querySelector('[data-sticky-atc-spacer]');
          if (!this._stickySpacer) {
            this._stickySpacer = document.createElement('div');
            this._stickySpacer.setAttribute('data-sticky-atc-spacer', '');
            this._stickySpacer.setAttribute('aria-hidden', 'true');
            main.insertBefore(this._stickySpacer, main.firstChild);
          }
        }
        return this._stickySpacer;
      };

      /* Spacer shifts the whole page down; ignore that shift when testing ATC visibility
         or show/hide will oscillate (sticky dropdown glitch on mobile scroll). */
      this._stickySpacerHeight = () => {
        if (bar.hidden || !this._stickySpacer) return 0;
        return Math.round(parseFloat(this._stickySpacer.style.height) || 0);
      };

      this._stickyPlaceBar = () => {
        const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        const top = Math.max(0, Math.round(headerBottom));
        bar.style.setProperty('--beam-sticky-bar-top', top + 'px');
        const spacer = this._stickyEnsureSpacer();
        if (!spacer) return;
        if (bar.hidden) {
          spacer.style.height = '0px';
          return;
        }
        spacer.style.height = Math.round(bar.getBoundingClientRect().height) + 'px';
      };

      this._stickySentinelInView = () => {
        const rect = sentinel.getBoundingClientRect();
        const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        const clipTop = Math.max(0, headerBottom);
        const shift = this._stickySpacerHeight();
        const top = rect.top - shift;
        const bottom = rect.bottom - shift;
        return bottom > clipTop + 8 && top < window.innerHeight - 8;
      };

      this._stickyApply = (show) => {
        const visible = mq.matches && show;
        const currentlyVisible = !bar.hidden;
        if (currentlyVisible === visible) {
          this._stickyPlaceBar();
          return;
        }

        if (visible) {
          bar.hidden = false;
          bar.setAttribute('aria-hidden', 'false');
          bar.classList.add('is-entering');
          this._stickyPlaceBar();
          if (this._stickyEnterTimer) clearTimeout(this._stickyEnterTimer);
          this._stickyEnterTimer = setTimeout(() => {
            bar.classList.remove('is-entering');
            this._stickyEnterTimer = null;
          }, 240);
        } else {
          bar.classList.remove('is-entering');
          bar.hidden = true;
          bar.setAttribute('aria-hidden', 'true');
          this._stickyPlaceBar();
        }
      };

      this._stickySync = () => {
        if (!mq.matches) {
          this._stickyApply(false);
          return;
        }
        this._stickyApply(!this._stickySentinelInView());
      };

      this._stickyIo = new IntersectionObserver(() => this._stickySync(), { threshold: 0 });
      this._stickyIo.observe(sentinel);

      this._stickyOnMq = () => this._stickySync();
      this._stickyOnScroll = () => this._stickySync();

      if (mq.addEventListener) mq.addEventListener('change', this._stickyOnMq);
      else mq.addListener(this._stickyOnMq);
      window.addEventListener('scroll', this._stickyOnScroll, { passive: true });
      window.addEventListener('resize', this._stickyPlaceBar, { passive: true });
      this._stickyMq = mq;
      this._stickySync();
    }

    disconnectedCallback() {
      if (this._stickyIo) this._stickyIo.disconnect();
      if (this._stickyEnterTimer) {
        clearTimeout(this._stickyEnterTimer);
        this._stickyEnterTimer = null;
      }
      if (this._stickyMq) {
        if (this._stickyMq.removeEventListener) this._stickyMq.removeEventListener('change', this._stickyOnMq);
        else this._stickyMq.removeListener(this._stickyOnMq);
      }
      if (this._stickyOnScroll) window.removeEventListener('scroll', this._stickyOnScroll);
      if (this._stickyPlaceBar) window.removeEventListener('resize', this._stickyPlaceBar);
      if (this._stickySpacer && this._stickySpacer.parentNode) {
        this._stickySpacer.parentNode.removeChild(this._stickySpacer);
      }
    }

    share(btn) {
      const url = btn.dataset.shareUrl || location.href;
      const feedback = this.querySelector('[data-share-feedback]');
      if (navigator.share) { navigator.share({ url: url, title: document.title }).catch(() => {}); return; }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          if (feedback) { feedback.textContent = this.dataset.copied; feedback.classList.remove('beam-visually-hidden'); }
        }).catch(() => {});
      }
    }
  }
  if (!customElements.get('beam-buybox')) customElements.define('beam-buybox', BeamBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-product-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var place = function () {
      var slot = document.querySelector('[data-promo-slot]');
      if (!slot) return;
      var nodes = document.querySelectorAll('[data-promo-embed="buybox"]');
      if (!nodes.length) return;
      var fresh = null;
      nodes.forEach(function (el) {
        if (!slot.contains(el)) fresh = el;
      });
      var src = fresh || nodes[nodes.length - 1];
      if (src.parentNode !== slot) {
        slot.replaceChildren(src);
      }
      src.classList.add('is-placed');
      slot.hidden = false;
      slot.removeAttribute('hidden');
    };
    window.__beamPlaceProductPromo = place;
    place();
    if (!window.__beamPlaceProductPromoBound) {
      window.__beamPlaceProductPromoBound = true;
      document.addEventListener('shopify:section:load', place);
      document.addEventListener('shopify:section:reorder', place);
      document.addEventListener('shopify:section:select', place);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-region-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-region-search]');
      if (!input) return;
      var overlay = input.closest('.beam-region-selector');
      if (!overlay) return;
      var term = input.value.trim().toLowerCase();
      var items = overlay.querySelectorAll('[data-region-item]');
      items.forEach(function (item) {
        var hay = item.getAttribute('data-search-term') || '';
        item.hidden = term !== '' && hay.indexOf(term) === -1;
      });
      overlay.querySelectorAll('[data-region-group]').forEach(function (group) {
        var visible = group.querySelectorAll('[data-region-item]:not([hidden])').length;
        group.hidden = visible === 0;
      });
      var empty = overlay.querySelector('[data-region-empty]');
      if (empty) {
        var anyVisible = overlay.querySelectorAll('[data-region-item]:not([hidden])').length;
        empty.hidden = anyVisible !== 0;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beam-video-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Poster / play button → hydrate sources on first gesture only (keeps LCP clean).
    document.addEventListener('click', function (e) {
      var player = e.target.closest('.beam-video-gallery__player');
      if (!player || player.classList.contains('is-playing')) return;
      var video = player.querySelector('video');
      if (!video) return;
      if (!video.dataset.loaded) {
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.dataset.src;
        });
        video.dataset.loaded = 'true';
        video.load();
      }
      player.classList.add('is-playing');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
